export const BASE_URL = import.meta.env.IS_POINTS_DEV ? 'http://13.58.48.206:3000' : 'https://points-api.apr.io';

